import {
  DocumentServicesObject,
  EditorClientSpecMapEntry,
} from '@wix/document-services-types';
import { Group } from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../../../types/platformApi';
import { EditorClientSpecMapEntryWithSections } from './types';
import { getSections } from './utils';
import { mapDefinitionToGroup } from './mappers';

export const getGroups = (
  documentServices: DocumentServicesObject,
  context: PlatformContext,
): Group[] => {
  const installedApps: EditorClientSpecMapEntry[] =
    documentServices.platform.getInstalledEditorApps();
  return installedApps
    .map((installedApp: EditorClientSpecMapEntry) => ({
      app: installedApp,
      sections: getSections(documentServices, context, installedApp),
    }))
    .filter(
      (installedAppWithSections: EditorClientSpecMapEntryWithSections) =>
        installedAppWithSections.sections.length,
    )
    .map(mapDefinitionToGroup);
};
